import Openable from './lib/openable';

class Modal extends Openable {
  constructor({
    element, zIndex = { element: 50, overlay: 40 }, overlay = true, overlayTriggersClose = true,
  }) {
    super({
      element, zIndex, overlay, overlayTriggersClose,
    });

    this.classes = {
      active: 'modal--active',
    };
  }
}

export default ({
  element, zIndex, overlay, overlayTriggersClose,
}) => new Modal({
  element, zIndex, overlay, overlayTriggersClose,
});
